/* HTTP Request */
export const HTTP_REQUEST_POST = "post";
export const HTTP_REQUEST_GET = "get";
export const HTTP_REQUEST_PUT = "put";
export const HTTP_REQUEST_PATCH = "patch";
export const HTTP_REQUEST_DELETE = "delete";

/* Toast */
export const TOAST_INFO = 1;
export const TOAST_ERROR = 2;
export const TOAST_SUCESS = 3;
export const TOAST_WARN = 4;
export const TOAST_THEME_DARK = "dark";
export const TOAST_THEME_LIGHT = "light";
export const TOAST_THEME_COLOR = "colored";

export const PK_LOCATION = "PK-LOC";
